export const Spinner = ({ style }) => {
  return <svg className="spinner" style={{display: "flex", ...style}} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle className="path" fill="none" strokeWidth="11" strokeLinecap="butt" cx="50" cy="50" r="40"></circle></svg>;
};